import { SanityImageURL } from "./sanityImageUrl";

import Image from "next/image";

export function SanityImage({ src, defaultImage, ...rest }) {
    let url = SanityImageURL(src, defaultImage, rest.width, rest.height);

    // Fallback if URL is null/undefined/empty
    if (!url && defaultImage) {
        url = defaultImage;
    }

    if (!url) {
        return null;
    }

    return (
        <Image
            {...rest}
            src={url}
            width={rest.width}
            height={rest.height}
            alt={rest.alt || "Image"}
            unoptimized={rest.unoptimized ? rest.unoptimized : false}
        />
    );
}
